import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'
import { contractAddress } from "../constants";
const oraclesControllerAddress = contractAddress.oraclesController;
export async function getMvuBalance(){
    let balance;
    balance = await ContractStore.call("MvuToken", "balanceOf", [Web3Store.account]);
    console.log("balance from Token.js " + balance);
    return balance;
}

export async function updateAllowance(spender,  value) {
    console.log("updating allowance to " + value + " for " + spender);
    return ContractStore.exec("MvuToken", "approve", [
        spender,
        value
    ], {
        from: Web3Store.account
    });

}


export async function getAllowance(){
    let allowance;
    allowance = await ContractStore.call("MvuToken", "allowance", [Web3Store.account, oraclesControllerAddress]);
    console.log("allowance for user " + allowance);
    return allowance;
}


// WEBPACK FOOTER //
// ./src/contract/Token.js